import { render, staticRenderFns } from "./ScheduleBox.vue?vue&type=template&id=532b7838&"
import script from "./ScheduleBox.vue?vue&type=script&lang=js&"
export * from "./ScheduleBox.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports